import React, { useEffect, useState, useRef } from "react";
import Header2 from "../../components/header/Header2";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import Breadcrumb from "../../components/breadcrumb";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import logo from "../../assets/siteimages/logo.png";


import { Tab, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";




function AstroPaymentnew() {
     const [toggle, setToggle] = useState({ key: "", status: false });
      const [isShowMobile, setShowMobile] = useState(false);
      const navigate = useNavigate();
    
      const handleToggle = (key) => {
        if (toggle.key === key) setToggle({ status: false });
        else setToggle({ status: true, key });
      };
    
      const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
          ? getMobile.classList.add("modal-menu--open")
          : getMobile.classList.remove("modal-menu--open");
      };
    
      useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({ live: false });
        window.wow.init();
      }, []);
    
      const [categories, setCategories] = useState([]);
      const [categoriesnew, setCategoriesnew] = useState([]);
      const [categoriesnew1, setCategoriesnew1] = useState([]);
      const [categoriesnew2, setCategoriesnew2] = useState([]);

      const [promoCode, setPromoCode] = useState("");
  const [promoMessage, setPromoMessage] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [appliedPromo, setAppliedPromo] = useState(null);


  const { id } = useParams();
  const [reservation, setReservation] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_BASE = "https://adhigyanam-e92bf1bbbdb1.herokuapp.com";
  // Fetch Nav Data
  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [res1, res2, res3, res4] = await Promise.all([
          axios.get(`${API_BASE}/blogcategoriessort`),
          axios.get(`${API_BASE}/horoscopecategoriessort`),
          axios.get(`${API_BASE}/astrocategoriessort`),
          axios.get(`${API_BASE}/coursecategoriessort`),
        ]);
        setCategories(res1.data);
        setCategoriesnew(res2.data);
        setCategoriesnew1(res3.data);
        setCategoriesnew2(res4.data);
      } catch {}
    };
    fetchAll();
  }, []);

  useEffect(() => {
    const fetchReservation = async () => {
      try {
        const storedUserId = localStorage.getItem("userId");
        const res = await axios.get(
          `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/api/get-reservation-details/${id}?userId=${storedUserId}`
        );
        setReservation(res.data);
      } catch (err) {
        console.error("Error fetching reservation details:", err);
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchReservation();
  }, [id]);

  const handleApplyPromo = async () => {
  if (!promoCode) {
    setPromoMessage("Please enter a promo code.");
    return;
  }

  try {
    const response = await axios.post(
      "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/validatepromocodeastronew",
      {
        code: promoCode,
        astrologerId: reservation.astrologer_id,
        category: reservation.booking_category,
      }
    );

    const {
      valid,
      discountType,
      discountPercent,
      discountAmount: cashDiscount,
      promoRecord,
      message,
    } = response.data;

    if (!valid) {
      setDiscountAmount(0);
      setAppliedPromo(null);
      setPromoMessage(message || "Promo code not valid.");
      return;
    }

    let discount = 0;

const fee = Number(reservation?.fee || 0);
const type = Number(discountType);
const percent = Number(discountPercent || 0);
const cash = Number(cashDiscount || 0);

// ✅ Flat cash discount
if (type === 0) {
  discount = cash;
}

// ✅ Percentage discount
if (type === 1) {
  discount = (fee * percent) / 100;
}

// ✅ Safety cap
discount = Math.min(discount, fee);

    setDiscountAmount(discount);
    setAppliedPromo(promoRecord);
    setPromoMessage(`Promo applied! You saved ₹${discount.toFixed(2)}.`);
  } catch (error) {
    console.error("Promo validation failed:", error);
    setDiscountAmount(0);
    setAppliedPromo(null);
    setPromoMessage("Something went wrong while validating the promo code.");
  }
};

const [customer, setCustomer] = useState(null);
const [customerLoading, setCustomerLoading] = useState(true);
const customerPromiseRef = useRef(null);

const fetchCustomer = async () => {
  const storedUserId = localStorage.getItem("userId");

  if (!storedUserId) {
    setCustomerLoading(false);
    return null;
  }

  try {
    const { data } = await axios.get(
      `https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getuserbyid/${storedUserId}`
    );

    const customerData = {
      fullName: data.Named || "",
      email: data.Email || "",
      contactNo: String(data.Cno || ""),
    };

    setCustomer(customerData);

    return customerData;

  } catch (err) {

    console.error(
      "❌ Error fetching customer:",
      err
    );

    return null;

  } finally {

    setCustomerLoading(false);

  }
};

useEffect(() => {

  customerPromiseRef.current =
    fetchCustomer();

  return () => {
    customerPromiseRef.current = null;
  };

}, []);

const finalPayable = reservation
  ? (reservation.fee - discountAmount).toFixed(2)
  : "0.00";

const handleRazorpayPayment = async () => {
  try {
    const userId = localStorage.getItem("userId");
    const reservationId = reservation?.reservation_id;

    const finalAmount = Math.max(
      Number(reservation?.fee || 0) -
        Number(discountAmount || 0),
      0
    );

    // ----------------------------------------------------
    // VALIDATION
    // ----------------------------------------------------

    if (!userId || !reservationId) {
      alert(
        "Missing user or reservation info. Please try again."
      );
      return;
    }

    if (finalAmount <= 0) {
      alert(
        "Invalid payment amount. Please try again."
      );
      return;
    }


    // ----------------------------------------------------
    // CUSTOMER DETAILS
    // ----------------------------------------------------

    let customerInfo = customer;

    // If customer details are not ready yet,
    // wait for the EXISTING customer request.
    if (
      !customerInfo &&
      customerPromiseRef.current
    ) {

      console.log(
        "⏳ Waiting for customer details..."
      );

      customerInfo =
        await customerPromiseRef.current;
    }


    // Final safety fallback.
    // This should rarely be reached.
    if (!customerInfo) {

      console.log(
        "⚠️ Customer data unavailable. Fetching again..."
      );

      customerInfo =
        await fetchCustomer();
    }


    // Customer information could not be loaded.
    if (!customerInfo) {

      alert(
        "Unable to load your customer details. Please try again."
      );

      return;
    }


    // ----------------------------------------------------
    // CREATE RAZORPAY ORDER
    // ----------------------------------------------------

    const { data } = await axios.post(
      "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/api/razorpay/payastronew",
      {
        amount: finalAmount,
        userId,
        reservationId,
        promoCode:
          appliedPromo?.Code || "",
        discountAmount:
          Number(discountAmount || 0),
      }
    );


    // ----------------------------------------------------
    // VALIDATE ORDER RESPONSE
    // ----------------------------------------------------

    if (
      !data?.key ||
      !data?.orderId
    ) {

      console.error(
        "❌ Invalid Razorpay order response:",
        data
      );

      alert(
        "Unable to initiate payment. Please try again."
      );

      return;
    }


    // ----------------------------------------------------
    // RAZORPAY CHECKOUT
    // ----------------------------------------------------

    const options = {

      key:
        data.key,

      amount:
        data.amount,

      currency:
        data.currency,

      name:
        "Adhigyanam",

      description:
        "Astrology Consultation",

      order_id:
        data.orderId,


      prefill: {

        name:
          customerInfo.fullName,

        email:
          customerInfo.email,

        contact:
          customerInfo.contactNo,

      },


      readonly: {

        contact:
          true,

        email:
          true,

      },


      // --------------------------------------------------
      // PAYMENT SUCCESS
      // --------------------------------------------------

      handler: function (response) {

        console.log(
          "✅ Razorpay Checkout completed:",
          response
        );


        /*
         * IMPORTANT:
         *
         * Do NOT update booking here.
         * Do NOT mark reservation as confirmed here.
         * Do NOT send email here.
         * Do NOT update RazorpayTransaction here.
         *
         * Razorpay webhook will process the payment on the
         * server side after payment.captured.
         */


        // ------------------------------------------------
        // STORE INFORMATION REQUIRED BY STATUS PAGE
        // ------------------------------------------------

        localStorage.setItem(
          "userId",
          userId
        );


        localStorage.setItem(
          "reservationId",
          String(reservationId)
        );


        localStorage.setItem(
          "paymentAmount",
          String(finalAmount)
        );


        localStorage.setItem(
          "transactionId",
          response.razorpay_payment_id
        );


        localStorage.setItem(
          "razorpayOrderId",
          response.razorpay_order_id ||
            data.orderId
        );


        // ------------------------------------------------
        // PROMO INFORMATION
        // ------------------------------------------------

        if (
          appliedPromo?.Code
        ) {

          localStorage.setItem(
            "promoCode",
            appliedPromo.Code
          );

          localStorage.setItem(
            "discountAmount",
            String(
              discountAmount || 0
            )
          );

        } else {

          localStorage.removeItem(
            "promoCode"
          );

          localStorage.removeItem(
            "discountAmount"
          );

        }


        // ------------------------------------------------
        // REDIRECT TO THIN STATUS PAGE
        // ------------------------------------------------

        window.location.href =
          `https://adhigyanam.com/payment-status-astro-new?tid=${response.razorpay_payment_id}`;

      },


      // --------------------------------------------------
      // PAYMENT FAILED
      // --------------------------------------------------

      modal: {

        ondismiss: function () {

          console.log(
            "ℹ️ Razorpay Checkout closed by user."
          );

        },

      },


      theme: {

        color:
          "#198754",

      },

    };


    // ----------------------------------------------------
    // CREATE RAZORPAY INSTANCE
    // ----------------------------------------------------

    const razorpay =
      new window.Razorpay(
        options
      );


    // ----------------------------------------------------
    // PAYMENT FAILED EVENT
    // ----------------------------------------------------

    razorpay.on(
      "payment.failed",
      function (response) {

        console.error(
          "❌ Razorpay payment failed:",
          response?.error
        );

        alert(
          response?.error?.description ||
          "Payment failed. Please try again."
        );

      }
    );


    // ----------------------------------------------------
    // OPEN RAZORPAY CHECKOUT
    // ----------------------------------------------------

    razorpay.open();


  } catch (error) {

    console.error(
      "❌ Razorpay payment initiation error:",
      error?.response?.data ||
      error.message ||
      error
    );

    alert(
      error?.response?.data?.error ||
      "Payment initiation failed. Please try again."
    );

  }
};



  return (
    <>
      <Helmet>
        <title>Astro Payment - Adhigyanam | Sauntesthyam LLP</title>
      </Helmet>

       <div className="menu-mobile-popup">
                         <div className="modal-menu__backdrop" onClick={handleMobile}></div>
                         <div className="widget-filter">
                           <div className="mobile-header">
                             <div id="logo" className="logo">
                               <Link to="/home">
                                 <img className="site-logo" src={logo} alt="Image" />
                               </Link>
                             </div>
                             <Link className="title-button-group" onClick={handleMobile}>
                               <i className="icon-close"></i>
                             </Link>
                           </div>
                 
                         <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
                           <div
                             className="header-customize-item button"
                             style={{
                               padding: "0px 0px",
                               background: "none",
                               backgroundColor: "#14a077",
                               borderRadius: "4px",
                               fontWeight: "700",
                               fontSize: "16px",
                               lineHeight: "21px",
                               color: "white",
                               borderColor: "transparent",
                               textTransform: "capitalize",
                             }}
                           >
                             <Link to="/astroservices" style={{ color: "#ffffff" }}>
                               Consult Now
                             </Link>
                           </div>
                           <div className="header-customize-item button">
                             <Link to="/login">My Account</Link>
                           </div>
                 
                           <div className="mobile-footer">
                             <div className="icon-infor d-flex aln-center">
                               <div className="icon">
                                 <span className="icon-call-calling">
                                   <span className="path1"></span>
                                   <span className="path2"></span>
                                   <span className="path3"></span>
                                   <span className="path4"></span>
                                 </span>
                               </div>
                               <div className="content">
                                 <p>Need help? 24/7</p>
                                 <h6>
                                   <Link to={`tel:918960708425`}>+91-8960708425</Link>
                                 </h6>
                               </div>
                             </div>
                             <p>
                               <b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016
                             </p>
                             <p style={{ marginTop: "15px" }}>
                               <b>Write To Us On</b>:{" "}
                               <Link to={`mailto:sauntesthyam@gmail.com`} style={{ textDecoration: "underline" }}>
                                 sauntesthyam@gmail.com
                               </Link>
                               ,{" "}
                               <Link to={`mailto:info@adhigyanam.com`} style={{ textDecoration: "underline" }}>
                                 info@adhigyanam.com
                               </Link>
                             </p>
                             <div className="wd-social d-flex aln-center" style={{ marginTop: "15px" }}>
                               <ul className="list-social d-flex aln-center">
                                 <li>
                                   <Link to="https://www.facebook.com/Adhigyanam">
                                     <i className="icon-facebook"></i>
                                   </Link>
                                 </li>
                                 <li>
                                   <Link to="https://www.instagram.com/the_vedic_astro">
                                     <i className="icon-instagram1"></i>
                                   </Link>
                                 </li>
                                 <li>
                                   <Link to="https://x.com/adhigyanam">
                                     <i className="icon-twitter"></i>
                                   </Link>
                                 </li>
                               </ul>
                             </div>
                           </div>
                         </div>
                       </div>

      <Header2 clname="act1" handleMobile={handleMobile} />
      <Breadcrumb title="Payment Summary" />

            <section
              className="booking-review-section"
              style={{
                padding: "60px 0",
                paddingTop: "30px",
                fontFamily: "'Inter', 'Segoe UI', sans-serif",
              }}
            >
              <div className="tf-container">
                <div className="row">
                  <div className="col-md-12 text-center mb-4">
                     <h2
                style={{
                  fontSize: "26px",
                  fontWeight: "700",
                  color: "#1e1e1e",
                  marginBottom: "10px",
                  letterSpacing: "-0.5px",
                }}
              >
                Complete Your Payment
              </h2>
              <p
                style={{
                  maxWidth: "650px",
                  margin: "0 auto 0px",
                  color: "#555",
                  fontSize: "15px",
                  lineHeight: "1.6",
                }}
              >
                Pay Now to confirm your booking and lock in your reserved slot.
              </p>
                    
                  </div>
      
                  <div className="col-md-10" style={{ margin: "auto" }}>
                    <div className="row g-4">
                               {loading ? (
            <div style={{ textAlign: "center", padding: "60px 0" }}>
              <div className="loader"></div>
              <p style={{ color: "#444", marginTop: "15px" }}>
                Fetching payment details...
              </p>
            </div>
          ) : !reservation ? (
            <div
              style={{
                textAlign: "center",
                color: "red",
                padding: "80px 20px",
              }}
            >
              Invalid or missing reservation details.
            </div>
          ) : (
            <div
              className="wow fadeInUp"
              data-wow-delay="0.2s"
              style={{
                display: "flex",
                gap: "25px",
                alignItems: "flex-start",
                flexWrap: "wrap",
              }}
            >
              {/* Left Section - Booking Summary */}
              <div
                style={{
                  flex: "1 1 68%",
                  background: "#fff",
                  borderRadius: "12px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                  padding: "30px",
                  lineHeight: "1.7",
                  color: "#333",
                }}
              >
                {/* <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    paddingBottom: "5px",
                  }}
                >
                  A. Booking Notifications
                </h2>
                <p style={{marginBottom:"20px"}}>Booking realted information will be sent to primary customer details as mentioned below.</p>

              <table
  style={{
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0",
    fontSize: "15px",
    marginBottom: "25px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  }}
>
  <tbody>
    <tr>
      <td
        style={{
          padding: "12px 15px",
          fontWeight: "600",
          width: "30%",
          borderBottom: "1px solid #e0e0e0",
          color: "#333",
          backgroundColor: "#f9fafb"
        }}
      >
        Reg. Customer
      </td>
      <td
        style={{
          padding: "12px 15px",
          width: "70%",
          borderBottom: "1px solid #e0e0e0",
          color: "#444",
        }}
      >
        {reservation.customer?.Named}
      </td>
    </tr>

    <tr>
      <td
        style={{
          padding: "12px 15px",
          fontWeight: "600",
          width: "30%",
          borderBottom: "1px solid #e0e0e0",
          color: "#333",
          backgroundColor: "#f9fafb",
        }}
      >
        Email Address
      </td>
      <td
        style={{
          padding: "12px 15px",
          width: "70%",
          borderBottom: "1px solid #e0e0e0",
          color: "#444",
        }}
      >
        {reservation.customer?.Email}
      </td>
    </tr>

    <tr>
      <td
        style={{
          padding: "12px 15px",
          fontWeight: "600",
          width: "30%",
          color: "#333",
          backgroundColor: "#f9fafb",
        }}
      >
        Contact Number
      </td>
      <td
        style={{
          padding: "12px 15px",
          width: "70%",
          color: "#444",
        }}
      >
        {reservation.customer?.Cno}
      </td>
    </tr>
  </tbody>
</table>

                
<hr/> */}
                

                <h2
                  style={{
                    fontSize: "18px",
                    fontWeight: "700",
                    paddingBottom: "5px",
                    margin: "30px 0 0px 0",
                  }}
                >
                  A. Quick Booking Summary
                </h2>
                 <p style={{marginBottom:"20px"}}>Here is a quick summary regarding your eConsulation booking. Booking related information will be sent to details as mentioned below.</p>

               <table
  style={{
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0",
    fontSize: "15px",
    marginBottom: "25px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  }}
>
  <tbody>
    <tr>
      <td
        style={{
          padding: "12px 15px",
          fontWeight: "600",
          width: "30%",
          borderBottom: "1px solid #e0e0e0",
          color: "#333",
          backgroundColor: "#f9fafb"
        }}
      >
        Astrologer
      </td>
      <td
        style={{
          padding: "12px 15px",
          width: "70%",
          borderBottom: "1px solid #e0e0e0",
          color: "#444",
        }}
      >
        {reservation.astrologer_name}
      </td>
    </tr>

    <tr>
      <td
        style={{
          padding: "12px 15px",
          fontWeight: "600",
          width: "30%",
          borderBottom: "1px solid #e0e0e0",
          color: "#333",
          backgroundColor: "#f9fafb",
        }}
      >
        Category
      </td>
      <td
        style={{
          padding: "12px 15px",
          width: "70%",
          borderBottom: "1px solid #e0e0e0",
          color: "#444",
        }}
      >
        {reservation.booking_category}
      </td>
    </tr>

     <tr>
      <td
        style={{
          padding: "12px 15px",
          fontWeight: "600",
          width: "30%",
          borderBottom: "1px solid #e0e0e0",
          color: "#333",
          backgroundColor: "#f9fafb",
        }}
      >
        Selected Plan
      </td>
      <td
        style={{
          padding: "12px 15px",
          width: "70%",
          borderBottom: "1px solid #e0e0e0",
          color: "#444",
        }}
      >
        {reservation.customer_name}
      </td>
    </tr>

     <tr>
      <td
        style={{
          padding: "12px 15px",
          fontWeight: "600",
          width: "30%",
          borderBottom: "1px solid #e0e0e0",
          color: "#333",
          backgroundColor: "#f9fafb",
        }}
      >
        Contact No
      </td>
      <td
        style={{
          padding: "12px 15px",
          width: "70%",
          borderBottom: "1px solid #e0e0e0",
          color: "#444",
        }}
      >
        {reservation.customer_phone}
      </td>
    </tr>

   

    <tr>
      <td
        style={{
          padding: "12px 15px",
          fontWeight: "600",
          width: "30%",
          color: "#333",
          backgroundColor: "#f9fafb",
        }}
      >
        Booking Date
      </td>
      <td
        style={{
          padding: "12px 15px",
          width: "70%",
          color: "#444",
        }}
      >
        {new Date(reservation.booking_date).toLocaleDateString("en-IN")}
      </td>
    </tr>
  </tbody>
</table>

               
              </div>

              {/* Right Section - Promo Code Placeholder */}
           <div
  style={{
    flex: "1 1 28%",
    background: "#fff",
    borderRadius: "12px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    padding: "25px",
    minHeight: "300px",
  }}
>
  <h2
    style={{
      fontSize: "18px",
      fontWeight: "700",
      paddingBottom: "5px",
      margin: "0px 0 0px 0",
    }}
  >
    B. Have a Promo Code?
  </h2>
  <p style={{ marginBottom: "20px" }}>
    Enter your promo code to claim a discount on your consultation fee.
  </p>

  <input
    type="text"
    value={promoCode}
    onChange={(e) => setPromoCode(e.target.value)}
    placeholder="Enter Promo Code"
    style={{
      width: "100%",
      padding: "10px 12px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      marginBottom: "10px",
      fontSize: "14px",
      color: "black",
      backgroundColor: "#fafafa",
      textTransform:"uppercase"
    }}
  />
  <button
    onClick={handleApplyPromo}
    style={{
      background: "#14a077",
      color: "#fff",
      border: "none",
      borderRadius: "6px",
      padding: "15px 16px",
      fontSize: "14px",
      fontWeight: "600",
      cursor: "pointer",
      width: "100%",
      textTransform: "none",
    }}
  >
    Apply Promo Code
  </button>

  {promoMessage && (
    <p
      style={{
        fontSize: "13px",
        marginTop: "8px",
        color: promoMessage.includes("saved") ? "#0f5132" : "#b22222",
        fontStyle: "italic",
      }}
    >
      {promoMessage}
    </p>
  )}

  {discountAmount > 0 && (
    <div
      style={{
        background: "#e8f8f1",
        border: "1px solid #a8e0c5",
        borderRadius: "8px",
        padding: "10px 14px",
        marginTop: "10px",
        marginBottom: "10px",
        color: "#0f5132",
        fontSize: "13px",
      }}
    >
      <strong>Congratulations</strong>! You just saved ₹
      {discountAmount.toFixed(2)}!
    </div>
  )}

  <div
    style={{
      background: "#fafafa",
      border: "1px solid #f2f2f2",
      borderRadius: "10px",
      padding: "20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "10px",
      marginTop: "20px",
    }}
  >
    <div>
      <strong>Net Payable Amount</strong>
      <p style={{ fontSize: "13px", color: "#666" }}>
        (Inclusive of all taxes)
      </p>
    </div>
    <div
      style={{
        background: "black",
        color: "#fff",
        padding: "6px 12px",
        borderRadius: "10px",
        fontWeight: "bold",
        fontSize: "14px",
      }}
    >
      ₹{finalPayable}
    </div>
  </div>

  <div style={{ textAlign: "center" }}>
    <button
  onClick={handleRazorpayPayment}
  style={{
    background: "#14A078",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "12px 40px",
    fontSize: "15px",
    fontWeight: "800",
    letterSpacing: "0.3px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    textTransform: "none",
  }}
>
  Proceed to Pay →
</button>
  </div>
</div>



            </div>
          )}
                    </div></div></div></div></section>

     

      {/* Floating Buttons */}
      <div
        className="floating-buttons"
        style={{
          position: "fixed",
          bottom: "20px",
          left: "20px",
          zIndex: "1000",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <a
          href={`tel:+918960708425`}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            backgroundColor: "#007BFF",
            borderRadius: "50%",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
            color: "white",
            fontSize: "28px",
          }}
        >
          <FaPhoneAlt />
        </a>

        <a
          href={`https://wa.me/918960708425`}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            backgroundColor: "#25D366",
            borderRadius: "50%",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
            color: "white",
            fontSize: "28px",
          }}
        >
          <FaWhatsapp />
        </a>
      </div>

      <Footer />
      <Gotop />
    </>
  );
}

export default AstroPaymentnew;